export enum SharingFailReasonEnum {
  FailedToShare = 'FailedToShare',
  ResourceRemoved = 'ResourceRemoved',
  ProcessingTimeExceeded = 'ProcessingTimeExceeded',
  CancelledByUser = 'CancelledByUser',
}
